module.exports = __webpack_public_path__ + "static/img/1.335781d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/honorsville/1.png
// module id = Lqcc
// module chunks = 1